import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)`
  align-self: center;
  margin: auto;
`;
